import { useAuth } from '@schooly/components/authentication';
import * as Sentry from '@sentry/react';
import { FC, PropsWithChildren, useEffect } from 'react';

const SENTRY_USER_ID_TAG = 'schooly_user_id';
const SENTRY_USER_ID_NOT_AUTHORIZED = 'not_authorized';

export const WithSentryUser: FC<PropsWithChildren> = ({ children }) => {
  const { currentUser } = useAuth();

  useEffect(() => {
    const userId = currentUser?.user_id ? currentUser.user_id : SENTRY_USER_ID_NOT_AUTHORIZED;

    Sentry.setTag(SENTRY_USER_ID_TAG, userId);

    Sentry.setUser({
      id: userId,
    });
  }, [currentUser?.user_id]);

  return <>{children}</>;
};
